import { ReactNode } from "react";
import usePivotReport, {
  PivotReportContext,
  UsePivotReportProps,
} from "./usePivotReport";

export interface PivotReportProviderProps extends UsePivotReportProps {
  children?: ReactNode;
}

const PivotReportProvider: React.FC<PivotReportProviderProps> = ({
  children,
  ...props
}) => {
  const context = usePivotReport(props);

  return (
    <PivotReportContext.Provider value={context}>
      {children}
    </PivotReportContext.Provider>
  );
};
export default PivotReportProvider;
